const dateFormat = new Intl.DateTimeFormat("nl-NL");
const dateTimeFormat = new Intl.DateTimeFormat("nl-NL", {
  hour12: false,
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
});
const numberFormat = new Intl.NumberFormat("nl-NL");

export const dateTimeFormatter = (date) => {
  try {
    const dateObj = new Date(date);
    return dateTimeFormat.format(dateObj);
  } catch (e) {
    return date;
  }
};

export const dateFormatter = (date) => {
  try {
    const dateObj = new Date(date);
    return dateFormat.format(dateObj);
  } catch (e) {
    return date;
  }
};

export const numberFormatter = (num) => {
  const res = Number(num);
  if (isNaN(res)) {
    return num;
  } else {
    return numberFormat.format(res);
  }
};

export const histogramTooltipFormat = new Intl.NumberFormat("nl-NL", {
  style: "decimal",
  maximumFractionDigits: 2,
});
